import ProactiveGreeting from 'components/GladChat/ProactiveGreeting/ProactiveGreeting';

export default ProactiveGreeting;
